export const DEFAULT_USER_FILTER_TYPE = "all";
